import { Injectable } from '@angular/core';
import { APP_CONFIG } from '../../app.config';
import { Params } from '../../shared/models/params.model';
import { RequestService } from '../../shared/services/request.service';
import { Pixel } from './models/pixel.model';

@Injectable()
export class ToolsService {
  constructor(private requestService: RequestService) {}

  async savePixel(params: Params, pixel: Pixel): Promise<Params> {
    params.value = JSON.stringify(pixel.toJson());
    const data: Params = JSON.parse(JSON.stringify(params));

    if (params.id) {
      return await this.requestService.putData(APP_CONFIG.WEBSERVICE.SAVE_META_PIXEL, data);
    } else {
      return await this.requestService.postData(APP_CONFIG.WEBSERVICE.SAVE_META_PIXEL, data);
    }
  }
}



// WEBPACK FOOTER //
// ./src/app/pages/tools/tools.service.ts